import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { PlayService } from 'src/app/pages/play/play.service';
import { QuestionsService } from 'src/app/pages/play/questions/questions.service';
import { RhythmService } from 'src/app/pages/rhythm/rhythm.service';

@Component({
  selector: 'nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})

export class NavMenuComponent extends BaseComponent{

  @Input()
  public modeType: string = 'play';

  public exitModalShow: boolean = false;

  constructor(
    public eRef: ElementRef,
    public activatedRoute: ActivatedRoute,
    public playIntroService: PlayService,
    public questionsService: QuestionsService,
    public rhythmsService: RhythmService,
    private router: Router
    ) {
    super();
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    // console.log('========= event.target')
    // console.log(event.target)
    // console.log('=====this.questionsService.showMenu')
    // console.log(this.questionsService.showMenu)
    // console.log('=====document.querySelector(".burger-container")')
    // console.log(document.querySelector('.burger-container').contains(event.target))
    // console.log('=====this.eRef.nativeElement.contains(event.target)')
    // console.log(this.eRef.nativeElement.contains(event.target))
    if(this.questionsService.showMenu &&
      document.querySelector('.nav-menu-overlay.active').contains(event.target)
      // !this.eRef.nativeElement.contains(event.target)
    ) {
      this.questionsService.navigateWish = null;
      this.exitModalShow = false;

      this.questionsService.pausedGame = false;
      this.questionsService.questionMediaAnimation = false;
      this.questionsService.showMenu = false;
      
      this.rhythmsService.pausedGame = false;
      this.rhythmsService.questionMediaAnimation = false;
      this.rhythmsService.showMenu = false;
    }
  }

  public goBackToMainPage(){
    // this.pauseGame();
    this.router.navigate(['/starter-kit']);
  }

  public exitGameWarning($event, location = null): void {
    $event.preventDefault();

    if(this.modeType == 'play'){
      this.questionsService.navigateWish = location;
      this.questionsService.toggleMenu();
      this.exitModalShow = true;
    }else{
      this.redirectTo(location);
      this.rhythmsService.toggleMenu();
    }
  }

  public confirmAction($event): void {
    $event.preventDefault();
    
    this.exitModalShow = false;
    this.redirectTo(this.questionsService.navigateWish);
  }

  public cancelAction($event): void {
    $event.preventDefault();
    
    this.questionsService.navigateWish = null;
    this.exitModalShow = false;
    this.questionsService.toggleMenu();
  }

  public redirectTo(location): void {

    const [path, queryParams] = location.split('?');
    
    const queryParamsObject = {};
    if (queryParams) {
      const params = queryParams.split('&');
      params.forEach(param => {
        const [key, value] = param.split('=');
        queryParamsObject[key] = value;
      });
    }


    this.questionsService.isDone = false;
    this.questionsService.resetQuestionsService();
    
    // const location = this.questionsService.navigateWish;
    if(path){
      if(path == 'restart'){
        this.playIntroService.restartPlayService();
        this.router.navigate([`/play`]);
      }else{
        this.playIntroService.resetPlayService();
        this.router.navigate([`/${path}`],{ queryParams: queryParamsObject });
      }
    }else{
      this.router.navigate(['/']);
    }
  }
}
